module.exports = __webpack_public_path__ + "static/media/eraseInstance.ac126509.md";